import React, { Component } from 'react';

class Ticker4 extends Component {


    render() {

        return (

          <div class="ticker-wrap-4">
            <div class="ticker-wrap">
            <div class="ticker">
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
              <div class="ticker__item">FROG to the Moon! 🚀</div>
            </div>
            </div>
            </div>)
    }
}

export default Ticker4;